<div class="grid-wrapper">
    <div class="grid-row-1-col-1">
      <app-date-selector (changeDate)="dateChanged($event)" [showInterval]="true"
        [setDisableSelector]="isLoading">
      </app-date-selector>
    </div>
</div>

<div class=" mat-elevation-z5" style="padding: 20px;margin-right:20px;">
  <div class="title">{{ lblTitle }}</div>
  <dx-data-grid #timebankTimes class="pointer" [dataSource]="dataSource"
                [rowAlternationEnabled]="true"
                [columnAutoWidth]="true"
                (onCellPrepared)="onCellPrepared($event)">
    <dxo-group-panel [visible]="true"></dxo-group-panel>
    <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
    <dxo-paging [pageSize]="15"></dxo-paging>
    <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-export [enabled]="true"></dxo-export>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
    <dxi-column dataField="Employee" [caption]="this.languageService.LNG('Label.Employee')"></dxi-column>
    <dxi-column dataField="EmployeeDepartment" [caption]="this.languageService.LNG('Label.Employee.Department.Short')" [visible]="false"></dxi-column>
    <dxi-column dataField="Date_YYYYMMDD" [caption]="this.languageService.LNG('Label.Date')" groupCellTemplate="dateGroupTemplate" cellTemplate="dateCellTemplate" [calculateSortValue]="customDateSort" sortOrder="asc"></dxi-column>
    <dxi-column dataField="TimeTypeCode" [caption]="this.languageService.LNG('Label.TimeType')"></dxi-column>
    <dxi-column dataField="Project" [caption]="this.languageService.LNG('Label.Project')" [visible]="false"></dxi-column>
    <dxi-column dataField="TimeDepartment" [caption]="this.languageService.LNG('Label.Department')"></dxi-column>
    <dxi-column dataField="HoursAndMinutes" [caption]="this.languageService.LNG('Label.Hours.Minutes.Short')"></dxi-column>
    <dxi-column dataField="TotSecondsAsHours" [caption]="this.languageService.LNG('Label.Hours')" alignment="left">
      <dxo-format type="fixedPoint"
                  [precision]="2"></dxo-format>
    </dxi-column>

    <div *dxTemplate="let data of 'dateCellTemplate'">
      <span>{{data.data.Date_dDDMMYYYY}}</span>
    </div>
    <div *dxTemplate="let data of 'dateGroupTemplate'">
      <span>{{groupTemplate(data)}}</span>
    </div>

    <dxo-summary [calculateCustomSummary]="calculateSummary">
      <dxi-total-item name="customSumHours"
                      summaryType="custom"
                      displayFormat="{0}"
                      showInColumn="HoursAndMinutes">
      </dxi-total-item>
      <dxi-group-item name="customSumHours"
                      summaryType="custom"
                      alignByColumn="true"
                      showInColumn="HoursAndMinutes">
      </dxi-group-item>
      <dxi-total-item name="customSumHoursDecimal"
                      summaryType="custom"
                      displayFormat="{0}"
                      showInColumn="TotSecondsAsHours">
      </dxi-total-item>
      <dxi-group-item name="customSumHoursDecimal"
                      summaryType="custom"
                      alignByColumn="true"
                      showInColumn="TotSecondsAsHours">
      </dxi-group-item>
    </dxo-summary>
  </dx-data-grid>
</div>

<div class=" mat-elevation-z5" style="padding: 20px;margin-right:20px;margin-top: 20px">
  <div class="title">{{ lblTitleLogg }}</div>
  <dx-data-grid #balanceLogg class="pointer "  [dataSource]="dataSourceBalanceLog"
                  [rowAlternationEnabled]="true"
                  [columnAutoWidth]="true">
          <dxo-group-panel [visible]="true"></dxo-group-panel>
          <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
          <dxo-paging [pageSize]="15"></dxo-paging>
          <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>
          <dxo-header-filter [visible]="true"></dxo-header-filter>
          <dxo-export [enabled]="true"></dxo-export>
          <dxo-sorting mode="multiple"></dxo-sorting>
          <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
          <dxi-column dataField="Employee" [caption]="this.languageService.LNG('Label.Employee')" ></dxi-column>
          <dxi-column dataField="Date_YYYYMMDD" [caption]="this.languageService.LNG('Label.Date')" groupCellTemplate="dateGroupTemplate" cellTemplate="dateCellTemplate"  [calculateSortValue]="customDateSort" sortIndex="0" sortOrder="asc"   ></dxi-column>
          <dxi-column dataField="TimeTypeCode" [caption]="this.languageService.LNG('Label.TimeType')"   ></dxi-column>
          <dxi-column dataField="NumberBeforeString" [caption]="this.languageService.LNG('Label.Before')"   >
              <dxo-format
                  type="fixedPoint"
                  [precision]="2"
              ></dxo-format>
          </dxi-column>
          <dxi-column dataField="NumberString" [caption]="this.languageService.LNG('Label.New')"   >
              <dxo-format
                  type="fixedPoint"
                  [precision]="2"
              ></dxo-format>
          </dxi-column>
          <dxi-column dataField="NumberAfterString" [caption]="this.languageService.LNG('Label.After')"   >
              <dxo-format
                  type="fixedPoint"
                  [precision]="2"
              ></dxo-format>
          </dxi-column>
          <dxi-column dataField="TimeStamp_YYYYMMDDHHmm" [caption]="this.languageService.LNG('Label.Timestamp')" groupCellTemplate="timeStampGroupTemplate" cellTemplate="timeStampCellTemplate"  [calculateSortValue]="customTimeStampSort" sortIndex="0" sortOrder="asc"  ></dxi-column>
          <dxi-column dataField="UpdatedBy" [caption]="this.languageService.LNG('Label.UpdatedBy')" ></dxi-column>

          
        <div *dxTemplate="let data of 'dateCellTemplate'">
          <span>{{data.data.Date_dDDMMYYYY}}</span>
        </div>
        <div *dxTemplate="let data of 'dateGroupTemplate'">
          <span>{{groupTemplate(data)}}</span>
        </div>
        <div *dxTemplate="let data of 'timeStampCellTemplate'">
          <span>{{data.data.TimeStamp_dDDMMYYYYHHmm}}</span>
        </div>
        <div *dxTemplate="let data of 'timeStampGroupTemplate'">
          <span>{{groupTemplateTimeStamp(data)}}</span>
        </div>
  </dx-data-grid>
</div>
